module.exports = __webpack_public_path__ + "img/consult-banner.c514fe6c.png";